import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type AuthorData_CorporateCustomer_Fragment = { __typename: 'CorporateCustomer' };

export type AuthorData_ExternalBank_Fragment = { __typename: 'ExternalBank' };

export type AuthorData_Guarantor_Fragment = { __typename: 'Guarantor' };

export type AuthorData_LocalCustomer_Fragment = (
  { __typename: 'LocalCustomer' }
  & Pick<SchemaTypes.LocalCustomer, 'id' | 'fullName' | 'email'>
);

export type AuthorData_Salesforce_Fragment = { __typename: 'Salesforce' };

export type AuthorData_SystemBank_Fragment = { __typename: 'SystemBank' };

export type AuthorData_User_Fragment = (
  { __typename: 'User' }
  & Pick<SchemaTypes.User, 'id' | 'email' | 'displayName'>
);

export type AuthorDataFragment = AuthorData_CorporateCustomer_Fragment | AuthorData_ExternalBank_Fragment | AuthorData_Guarantor_Fragment | AuthorData_LocalCustomer_Fragment | AuthorData_Salesforce_Fragment | AuthorData_SystemBank_Fragment | AuthorData_User_Fragment;

export const AuthorDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AuthorData on Author {
  ... on User {
    id
    email
    displayName
  }
  ... on LocalCustomer {
    id
    fullName
    email
  }
}
    `;